import { useSyncExternalStore } from "react";
import useUiThemeState from "~/stores/ui/theme";

const DARK_QUERY = "(prefers-color-scheme: dark)";

function subscribe(onChange: () => void) {
  const media = window.matchMedia(DARK_QUERY);
  media.addEventListener("change", onChange);
  return () => media.removeEventListener("change", onChange);
}

const getSnapshot = () => window.matchMedia(DARK_QUERY).matches;
const getServerSnapshot = () => false;

/**
 * The selected UI mode with "system" resolved to the OS preference, so every
 * consumer (html class, data-theme, toasts, logos) agrees on light vs dark.
 */
export function useResolvedMode(): "light" | "dark" {
  const mode = useUiThemeState((s) => s.mode);
  const prefersDark = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot
  );

  if (mode === "system") return prefersDark ? "dark" : "light";
  return mode;
}
